export default __webpack_public_path__ + "static/media/research_facilities.9c583816.jpg";